import style from "../Intro.module.css";

function Curtain() {
    return (
        <div id={style.curtain_div}>
            <ul id={style.cd_logo}>
                <li>R</li><li>2</li><li>M</li><li>A</li><li>P</li><li>S</li>
                <li><span>R</span>ainfall <span>R</span>isk <span>M</span>onitoring <span>A</span>nd <span>P</span>rediction <span>S</span>ystem</li>
            </ul>
            <ul id={style.cd_version}>
                <li>Development version: Development version 1.048</li>
                <li>Produced by Ecobrain Software Development Lab</li>
                <li>COPYRIGHT &copy; AI for Climate & Disaster Management Center. All Rights RESERVED</li>
            </ul>
        </div>
    )
}

export default Curtain;